import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getFreeExtensionCancellationStatus,
  requestFreeExtensionCancellation,
} from '@/api/freeExtensionCancellation/freeExtensionCancellation';
import type { FreeExtensionCancellationStatus } from '@/@types/freeExtensionCancellation';

export const useGetFreeExtensionCancellationStatus = (enabled: boolean) => {
  const { isLoading, data, isError } = useQuery({
    queryKey: ['free-extension-cancellation'],
    queryFn: getFreeExtensionCancellationStatus,
    enabled,
    retry: 0,
    useErrorBoundary: false,
  });

  return {
    requestedAt: data?.requestedAt,
    initializing: enabled && (isLoading || isError),
  };
};

export const useRequestFreeExtensionCancellation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: requestFreeExtensionCancellation,
    onSuccess: (data) => {
      queryClient.setQueryData<FreeExtensionCancellationStatus | null>(['free-extension-cancellation'], data);
    },
  });

  return {
    isLoading,
    requestCancellation: mutateAsync,
  };
};
